<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useGit } from '~/store/git'
import { useLocaleThemePath } from '~/composables/locale'

const { gitlabList } = storeToRefs(useGit())
</script>

<template lang="pug">
section.git__gamma
  h4 {{ $t('git.gamma.title') }}
  p {{ $t('git.gamma.subtitle') }}
  .git__gamma__repos
    NuxtLink(
      v-for="(repo, index) in gitlabList"
      :key="`repo-${index}`"
      :to="useLocaleThemePath(`/git/${repo?.name}`)"
    )
      NuxtImg(
        v-if="repo?.asset?.nuxtPath || repo?.asset?.thumb"
        :src="repo?.asset?.nuxtPath || repo?.asset?.thumb"
        :provider="repo?.asset?.provider"
        :alt="$t('git.gamma.image.alt', { repo: repo.name })"
        :title="$t('git.gamma.image.title', { repo: repo.name })"
        :aria-label="$t('git.gamma.image.aria-label', { repo: repo.name })"
        :longdesc="$t( \
          'components.repo-card.image.longdesc', \
          { \
            repo: repo.name, \
            description: repo?.description \
              ? $t('git.gamma.image.longdesc-description', { description: repo.description }) \
              : '', \
          }, \
        )"
        width="64px"
        height="64px"
        loading="lazy"
      )
      div
        span {{ repo?.name }}
        p {{ repo?.description }}
</template>

<style lang="sass" scoped>
.git__gamma
  @apply w-full h-full flex-center flex-col lg:gap-4
  h4
    @apply text-3xl lg:text-4xl xl:text-6xl mb-2 font-bold text-primary text-center text-animated
  p
    @apply text-2xl lg:text-3xl mb-6 text-secondary text-center
  .git__gamma__repos
    @apply w-full max-w-[600px] mx-auto flex flex-col max-h-[50vh] overflow-auto scrollbar-secondary border-y border-primary
    a
      @apply w-full flex justify-between items-center gap-6 p-2 bg-transparent-dark border-y border-gray-700 hover:border-gray-400 transition-all
      img
        @apply h-[64px] w-[64px] rounded-lg object-contain object-center
      & > div
        @apply w-full
        span
          @apply text-lg text-primary
        p
          @apply text-sm text-white text-left
      &:hover > div
        span, p
          @apply underline
</style>
